import { t } from "i18next";

import { Box, Typography } from "@mui/material";

import {
  hasVehicleTypesSubtitle,
  instructionsSubtitleSx
} from "@/src/pages/consumer/HomePage/components/HomePageHeader/homePageHeader.styles";
import { CONSUMER_HOMEPAGE_PREFIX } from "@/src/pages/consumer/HomePage/homePage.constants";

import { VehicleType } from "@/src/types/types";

interface HeroInstructionsListProps {
  vehicleType: VehicleType;
}

const NON_BREAKING_SPACE = "\u00A0";

const HeroInstructionsList = (props: HeroInstructionsListProps) => {
  const { vehicleType } = props;
  const showSubtitle = hasVehicleTypesSubtitle(vehicleType);

  return (
    <ol>
      <li style={showSubtitle ? undefined : { marginBottom: 0 }}>
        <Box sx={{ display: "flex", flexDirection: "column", flex: 1 }}>
          {t(`${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.instructionBullet1`)}

          <Typography variant="body1" sx={instructionsSubtitleSx}>
            {showSubtitle
              ? t(`${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.vehicleTypes`)
              : NON_BREAKING_SPACE}
          </Typography>
        </Box>
      </li>

      <li>
        {t(`${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.instructionBullet2`)}
      </li>

      <li>
        {t(`${CONSUMER_HOMEPAGE_PREFIX}.${vehicleType}.instructionBullet3`)}
      </li>
    </ol>
  );
};

export default HeroInstructionsList;
